import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/ChannelGroups",
        name: "ChannelGroups",
        component: () => import("@/components/channels/_ChannelGroups.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewChannelGroupsUI,
            breadcrumbs: {
                icon: "channels-group-icon",
                paths: []
            },
            title: "navbar.channelGroups"
        }
    },
    {
        path: "/ChannelGroups/:channelGroupId/update",
        name: "UpdateChannelGroup",
        component: () => import("@/components/channels/_ChannelGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateChannelGroup,
            breadcrumbs: {
                icon: "channels-group-icon",
                paths: [
                    ["/ChannelGroups", i18n.t("channelGroups.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/ChannelGroups/new",
        name: "CreateChannelGroup",
        component: () => import("@/components/channels/_ChannelGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateChannelGroup,
            breadcrumbs: {
                icon: "channels-group-icon",
                paths: [
                    ["/ChannelGroups", i18n.t("channelGroups.title")]
                ]
            },
            title: "channelGroups.newChannelGroup"
        },
        props: true
    },
    {
        path: "/ChannelGroups/:channelGroupId/preview",
        name: "channelGroupPreview",
        component: () => import("@/components/channels/_ChannelGroupPreview.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewChannelGroupsUI,
            layout: () => import("@/components/layouts/_BasicLayout.vue"),
            title: "common.preview"
        },
        props: true
    }
];
